// extracted by mini-css-extract-plugin
export default {"image":"style_image__4j2z0","primaryImg":"style_primaryImg__HthVG","options":"style_options__3OmrS","editorChoice":"style_editorChoice__lAX2G"};